import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";

const rootEl = document.getElementById( "single" );

if (rootEl) {

    const root = ReactDOM.createRoot(rootEl);

  const jobId = rootEl.getAttribute( 'data-job-id' );

  root.render(
    <React.StrictMode>
      <App jobId={ jobId } />
    </React.StrictMode>
  );
}
